// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4891) return "static/chunks/lib-microsoft-84fe64ed40841c31.js";
	if (chunkId === 4223) return "static/chunks/commons-e339daad5400fef0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2362":"b67eb0983a93a601","5585":"bc981ea46d24ab33","7207":"33bb5db5a658709a","8722":"74053304bbd122a4"}[chunkId] + ".js";
};